import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Modal,
  Fade,
  Backdrop,
  Checkbox,
  ListItemText,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import Page from "../../../components/Page";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import { ITemplateAdminPageProps } from "./../IAdminPageProps";
import LoadingSpinner from "src/components/LoadingSpinner";
import "src/pages/admin/home.css";
import ViewModal from "src/components/ViewModal";
import SimpleTabs from "src/components/TabView";
import TabPanel from "src/components/TabView/TabPanel";
import { Pagination } from "@material-ui/lab";
import { IUser } from "src/services";
// import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import { Delete, Edit } from "@material-ui/icons";
// import InfoIcon from "@material-ui/icons/Info";
// import { FILE_URL } from "src/constants";

const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

});


type IProps = ITemplateAdminPageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ITemplatesPageState {
  getChequeData?: any;
  modalVisible: boolean;
  loader: boolean;
  modalContent?: any;
  rejectModalVisible: boolean; // State to manage the reject modal visibility
  declineReason: string; // State to store the decline reason
  searchQuery: string;
  planId: string;
  paymentMethod: string;
  startDate: string;
  endDate: string;
  status: string;
  selectedTab: number,
  currentPage: number,
  totalPage: number,
  idRange: number,
  viewDetails: any,
  statusFilter: string,
  paymentby: string,
  planFilter: string,
  search: string,
  isEditOpen: boolean,
  selectedRow: any,
  selectedPlanAddon: any,
  addonSelect: any,
  addonOptions: any,
  addonPlanIds: any,
  editPaymentOptions: string,
  cancelSubscription: any,
  membershipIds: any,
  membershipID: any,
  noteInput: any, 
  noteModalVisible: boolean,
  NoteDate: any;
  NoteList: any;
  openEditNote:boolean;
  editText:any;
  editIndex: number;
  editableDate:boolean;
  dateChange:any;
  renewalStartDate: string;
  planOptions:any;
  customAddonPrice:number,
  customPlanPrice: number,
  isCustomPriceEnabled: boolean,
  customAddonPrices: Record<string | number, number>;
  customPlanPriceInput: string;
  customAddonInputs: Record<string | number, string>;
  planStandardPrice: number;
  selectedAddonPrices: Array<{
    addonId: number;
    price: string;
  }>;



}

const starterAddon: any = [
  { label: 'Customizable Questions', value: 1 , price: 100},
  { label: 'Parent Surveys', value: 2, price: 200 },
  { label: 'Athletic Director Surveys', value: 3, price: 150 },
  {label: 'Midseason', value: 4, price: 125}
]
const proAddon: any = [
  { label: 'Parent Surveys', value: 2, price: 200 },
  { label: 'Athletic Director Surveys', value: 3, price: 150 },
  {label: 'Midseason', value: 4, price: 125}
]
const premierAddon: any = [
  { label: 'Athletic Director Surveys', value: 3, price: 150 },
  {label: 'Midseason', value: 4, price: 125}
]
const eliteAddon: any = [
    {label: 'Midseason', value: 4, price: 125}
]

export default withStyles(styles)(
  withAxios(
    class UploadVideoPage extends Component<IProps, ITemplatesPageState> {
      public readonly state = this.buildState({
        modalVisible: false,
        getChequeData: [],
        loader: false,
        rejectModalVisible: false,
        isCustomPriceEnabled: false,
        declineReason: "",
        searchQuery: "",
        planId: "",
        paymentMethod: "",
        startDate: "",
        endDate: "",
        status: "all",
        selectedTab: 1,
        currentPage: 1,
        totalPage: 1,
        idRange: 1,
        viewDetails: {},
        statusFilter: "",
        paymentby: "",
        planFilter: "",
        search: "",
        isEditOpen: false,
        selectedRow: {},
        selectedPlanAddon: "",
        addonSelect: [],
        addonOptions: [],
        planOptions:[],
        // starterAddon,
        addonPlanIds: [],
        editPaymentOptions: 'check',
        cancelSubscription: false,
        membershipIds: [],
        membershipID: "",
        noteInput: '', 
      noteModalVisible: false,
      NoteDate:"",
      NoteList:[],
      openEditNote: false,
      editText:"",
      editIndex: -1, 
      editableDate:false,
      dateChange:"",
      renewalStartDate: "",
      customAddonPrice:0,
      customPlanPrice:0,
       customAddonPrices: {},
      customPlanPriceInput: "",
      customAddonInputs: {},
      planStandardPrice:0,
      selectedAddonPrices: [],

      });

  public getPurchasableAddonsByPlanId(planid: any) {
    // Returns addon IDs that can be purchased separately (NOT included by default)
    switch (planid) {
      case 2:
        return [1, 2, 3, 4]
      case 3:
        return [2, 3, 4]
      case 4:
        return [3, 4]
      case 5:
        return [4]
      default:
        return []
    }
  }

  public async componentDidMount() {
  this.getChequeDataHandler();

  const planRes: any = await this.buildGet(this, "payment/getPlan")();
  console.log("Plan type=====>", planRes);
    const addonRes: any = await this.buildGet(this, "payment/getAddonPlan")()
 console.log("adddonnnsss data::::", addonRes)
 const arr: any = [];
 addonRes?.data?.map((item:any)=>{
arr.push( { label: item?.title + " " + "$"+item?.price , value: item?.id, price: item?.price })
 })
console.log("Addons array", arr)
//  this.setState({addonOptions: arr})
const planOptions = planRes?.data?.map((item: any) => ({
    label: item?.title,
    // + " $" + item?.price,
    value: item?.id,
    price: item?.price,
  })) || [];

  const addonOptions = addonRes?.data?.map((item: any) => ({
    label: item?.title,
    // + " $" + item?.price,
    value: item?.id,
    price: item?.price,
  })) || [];

  this.setState({
    planOptions,
    addonOptions,
  });
}

      public getTotalPages(totalItems: any, itemsPerPage: any) {
        return Math.ceil(totalItems / itemsPerPage);
      }
      public async getChequeDataHandler() {
        this.setState({ loader: true })
        let totalItems = 15;
        const itemsPerPage = 15;
        const subUrl = this.state.selectedTab === 0 ? "getListCheque" : "getListSubscrition"
        let url = `payment/${subUrl}?pageTotal=${itemsPerPage}&page=${this.state.currentPage}`
        if (this.state.statusFilter !== "") {
          url = url + "&status=" + this.state.statusFilter
        }
        if (this.state.paymentby !== "") {
          url = url + "&paymentMethod=" + this.state.paymentby
        }
        if (this.state.planFilter !== "") {
          url = url + "&planId=" + this.state.planFilter
        }
        if (this.state.search !== "") {
          url = url + "&search=" + this.state.search
        }
        const res: any = await this.buildGet(this, url)()
        console.log("getListCheque=====>", res)
        if (res?.totalCount) {
          totalItems = res?.totalCount
          const totalPages = this.getTotalPages(totalItems, itemsPerPage);
          this.setState({ totalPage: totalPages })
        }

        if (res.status && res?.data?.length > 0) {

          this.setState({ loader: false, getChequeData: res?.data })
        } else {
          this.setState({ loader: false })
        }

      }

      public handlePageChange = (event: any, value: any) => {
        this.setState({ currentPage: value }, () => {
          this.getChequeDataHandler()
        })
      }

      public async checkPendingCheck(id: any) {
        this.setState({ loader: true })
        const res: any = await this.buildGet(this, `payment/getOnecheckHistory/${id}`)()
      //  http://localhost:3002/api/payment/getOnecheckHistory/331 old one
        console.log("checkPendingCheck===========>", res)
        this.setState({ loader: false })
// if status false then open subscription plan pop up if true then open customer has pending request
        if (res?.status) {
          // if (res?.data.length > 0) {
          //   return false
          // } else {
          //   return true
          // }
          return true
        } else {
          return false
        }
        
        // curl --location 'http://localhost:3002/api/payment/getOnecheckHistory/331'
      }
      public getDetails() {
        console.log("hhh")
      }

      public getPageItems() {
        const startIndex = (this.state.currentPage - 1) * 15; // Starting index
        return startIndex + 1
      }

      // Status update API
      public async updateStatusHandler(id: number, Status: string) {
        this.setState({ loader: true });
        try {
          const res: any = await this.buildPut(
            this,
            `/payment/chequeRequest/${id}`
          )({
            status: Status,
          });

          if (res.status) {
            alert("Status updated successfully");
            this.getChequeDataHandler()
          } else {
            alert("Failed to update status. Please try again.");
          }
        } catch (error) {
          console.error("Error updating status:", error);
          alert("An error occurred. Please try again.");
        } finally {
          this.setState({ loader: false });
        }
      }

      public handleDeleteNote = (index: number, status:string) => {
        const updatedNoteList = [...this.state.NoteList];
        updatedNoteList.splice(index, 1);  // Remove the item at the specified index
        // this.setState({ NoteList: updatedNoteList });
        this.setState({ NoteList: updatedNoteList }, () => {
          console.log("Updated NoteList:", this.state.NoteList);
          this.updateNote(status, "deleteNote");
        });
      };

     public handleEdit = (status:boolean, index:number, text:any) => {
      const noteToEdit = this.state.NoteList[index];
        this.setState({
          openEditNote: status,
          editIndex: index,
          editText: noteToEdit.note,
        });
      };
      public handleNoteEdit = () => {
        const { NoteList, editIndex, editText } = this.state;       
        if (editText.trim() !== "") {
        if (editIndex !== -1) {
          const updatedNoteList = [...NoteList];
          updatedNoteList[editIndex].note = editText;
      
          this.setState(
            {
              NoteList: updatedNoteList,
              editIndex: -1,
              editText: "",
            },
            () => {
              this.setState({
                openEditNote: false,
              });
              this.updateNote("remove", "editNote"); // Call your API           
            }
          );
        }
      }else{
        alert("Please add note")
      }
      };
      
      
      public async updateNote(status:string, noteFrom: string) {
        try {
          if ((this.state.noteInput.trim() !== "" && noteFrom === "newNote") || 
         noteFrom === "deleteNote" || noteFrom === "editNote"
        ) {
         
          const res: any = await this.buildPut(this, `/payment/noteUpdate`)({
            membership_id: this.state.membershipID, // Assuming you have selected the row
            note: status === "remove" ?
            this.state.NoteList : this.state.noteInput, // Assuming you have the note text in `this.state.note`,
            type: status,
          });
      console.log("not updated", res, status)
      const noteData = res?.data?.note;
      if (noteData) {
        const list = JSON.parse(noteData);
        this.setState({
          NoteList: list,
          noteInput: "", 
        });
      } else {
        console.error("Note data is undefined or invalid");
      }
      // if(status !== "remove" ){ 
      //   this.handleCancelNote();
      // }
      this.getChequeDataHandler();
          // You can return the response or handle it as per your requirements
          return res;
        }else{
          alert("Please add note.")
        }
      
        } catch (error) {
          return { isError: true, message: error };
        }
      }
     public handleAddNote = (rowId: any, note: any, date: any, noteList:any) => {
      const noteData = noteList;
      if (noteData) {
        const list = JSON.parse(noteData);
        console.log("parsedata", list)
        this.setState({
          NoteList: list
        });
      } else {
        console.error("Note data is undefined or invalid");
        this.setState({
          NoteList: []
        });
      }
      
        this.setState({
          noteModalVisible: true,
          membershipID: rowId,
          // noteInput: note,
          NoteDate: date
        });
      };
      public handleCancelNote = () => {
        this.setState({
          noteModalVisible: false,
          noteInput: '', // Reset input
        });
      };
    


      public CFS(text: any = "") {
        return text
          ?.split(/([.!?]\s+)/) // Split by sentence-ending punctuation followed by space.
          ?.map((sentence: any) => sentence?.charAt(0)?.toUpperCase() + sentence?.slice(1))
          ?.join('');
      }

      public changeChequeName = (value: string) => {
        if (value === 'Cheque') {
          return 'Check'
        }
        return value
      }
      // public handleDateChange = (event: React.ChangeEvent<HTMLInputElement>, rowId: number) => {
      //   const newDate = event.target.value;
      
      //   this.setState((prevState) => {
      //     const updatedData = prevState.getChequeData.map((row: any) =>
      //       row.id === rowId
      //         ? { ...row, memberPayHistory: { ...row.memberPayHistory, validUpto: newDate } }
      //         : row
      //     );
      //     console.log("update daaaaa", updatedData)
      //     return { getChequeData: updatedData };
          
      //   }, async () => {
      //     // Call API or save function after state update
      //     // this.updateRenewableDate(rowId, newDate);
      //     try {
      //       const res: any = await this.buildPut(
      //         this,
      //         `/payment/updateMembership`
      //       )({
      //         "membership_id": rowId,
      //         "type": "date",
      //         "renewDate":newDate,
             
      //       });
      //       console.log("date changed", res)
      //       return res
      //     } catch (error) {
      //       return { isError: true, message: error }
      //     }
      //   });
      // };

      public handleClickDate = (rowId: number, date:any, startDate: any) => {
        this.setState({
         editableDate: true,
         membershipID: rowId,
         dateChange: date,
         renewalStartDate: startDate || "",
        });
      };
    
      public handleDateRenew = async () => {
        // const isConfirmed = window.confirm("Are you sure you want to renew the date?");
        
        // if (isConfirmed) {
            if (this.state.renewalStartDate && this.state.dateChange && this.state.dateChange < this.state.renewalStartDate) {
              window.alert("Renewal date cannot be less then start date.");
              return;
            }

            try {
              const res: any = await this.buildPut(
                this,
                `/payment/updateMembership`
              )({
                "membership_id": this.state.membershipID,
                "type": "date",
                "renewDate": this.state.dateChange,
               
              });
              this.setState({editableDate: false})
              this.getChequeDataHandler();
              return res
            } catch (error) {
              return { isError: true, message: error }
            }
          // } else {
          //   console.log("Date change cancelled.");
          // }
     
      };
      
      public handleDateChange = (event: React.ChangeEvent<HTMLInputElement>, rowId: number) => {
        const newDate = event.target.value;
        if (this.state.renewalStartDate && newDate < this.state.renewalStartDate) {
          window.alert("Renewal date cannot be less then start date");
          return;
        }
          // Update state only if confirmed
          this.setState((prevState) => {
            const updatedData = prevState.getChequeData.map((row: any) =>
              row.id === rowId
                ? { ...row, memberPayHistory: { ...row.memberPayHistory, validUpto: newDate } }
                : row
            );
            return { getChequeData: updatedData };
          }, async () => {
            // Call API or save function after state update
            // this.updateRenewableDate(rowId, newDate);
            try {
              const res: any = await this.buildPut(
                this,
                `/payment/updateMembership`
              )({
                "membership_id": rowId,
                "type": "date",
                "renewDate":newDate,
               
              });
              window.alert("Date renewed successfully")
              return res
            } catch (error) {
              return { isError: true, message: error }
            }
          });
      };
      
      

      public handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ statusFilter: event.target.value as string });
      };
      public paymentByChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ paymentby: event.target.value as string });
      };
      public planChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        this.setState({ planFilter: event.target.value as string });
      };

      public planEditChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedPlanId: any = event.target.value as string;
          const currentPlanId = this.state.selectedRow?.memberPayHistory?.plan?.id;
        
        // Prevent downgrade - block if selected plan is lower than current plan
        if (currentPlanId && Number(selectedPlanId) < Number(currentPlanId)) {
          window.alert("Plan downgrade is not allowed. Please select a plan that is equal to or higher than your current plan.");
          return; // Don't proceed with the change
        }
        
        const matchedPlan: any = this.state.planOptions?.find((p: any) => Number(p.value) === Number(selectedPlanId));
        const matchedPrice: number = matchedPlan ? Number(matchedPlan.price) : 0;
        this.setState({ selectedPlanAddon: selectedPlanId, planStandardPrice: matchedPrice }, () => {
          this.setState({ addonOptions: this.selectOptionAddon(), addonSelect: [], editPaymentOptions: this.state.selectedRow?.subscription_type }, () => {
            this.addonsIdHandlerOptions(this.state.selectedRow?.memberPayHistory?.subscription_id)
          })
        });
      };

      // public addonsCheck(id:any){


      // }
      public renderCheckStatusFilterDropdown() {
        return (
          <div>
            <FormControl variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.statusFilter}
                onChange={this.handleChange}
                label="Status"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'pending'}>Pending</MenuItem>
                <MenuItem value={'accepted'}>Paid</MenuItem>
                <MenuItem value={'declined'}>Block</MenuItem>
              </Select>
            </FormControl>
          </div>
        )
      }
      public renderStatusFilterDropdown() {
        return (
          <div>
            <FormControl variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={this.state.statusFilter}
                onChange={this.handleChange}
                label="Status"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={'active'}>Active</MenuItem>
                <MenuItem value={'deactive'}>Deactive</MenuItem>
                <MenuItem value={'cancelled'}>Cancelled</MenuItem>
              </Select>
            </FormControl>
          </div>
        )
      }
      public renderPaymentFilterDropdown() {
        return (
          <FormControl variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Payment Method</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={this.state.paymentby}
              onChange={this.paymentByChange}
              label="Payment Method"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              <MenuItem value={'free'}>Free</MenuItem>
              <MenuItem value={'cheque'}>Check</MenuItem>
              <MenuItem value={'stripe'}>Stripe</MenuItem>
            </Select>
          </FormControl>
        )
      }
      public renderPlanFilterDropdown() {
        return (
          <FormControl variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Plan Type</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={this.state.planFilter}
              onChange={this.planChange}
              label="Plan Type"
            >
              {this.state.planOptions?.filter((plan: any) => {
                const label = String(plan.label).toLowerCase();
                return label.includes("free") || label.includes("elite");
              }).map((plan: any) => (
                <MenuItem key={plan.value} value={plan.value}>
                  <ListItemText primary={plan.label} secondary={`$${plan.price}/yr`} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )
      }
      public handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ search: event.target.value });
      };
      public handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
          this.handleSubmit();
        }
      };
   
      public renderSearchFilter() {
        return (
          <div>
            <TextField
              className="textfield-search"
              label="Search by Name or School"
              variant="outlined"
              value={this.state.search}
              onChange={this.handleSearch}
              onKeyDown={this.handleKeyDown}
            />
          </div>
        )
      }
      public handleSubmit = () => {
        this.setState({
          getChequeData: [],
          currentPage: 1,
          totalPage: 1,
          idRange: 1,
        }, () => {
          this.getChequeDataHandler()
        })
      };

      public handleViewClick = (row: any, source: string = "") => {
        const planId = row?.plan?.id || row?.memberPayHistory?.plan?.id;
        const purchasableAddonIds = this.getPurchasableAddonsByPlanId(planId);
        const planAmount = Number(row?.memberPayHistory?.plan?.price ?? row?.plan?.price ?? 0);
        const paymentMethod = String(row?.subscription_type ?? row?.payment?.payment_method ?? "").toLowerCase();
        const basePaymentAmount = Number(row?.memberPayHistory?.price ?? row?.price ?? row?.payment?.payment_amount ?? 0);
        const paymentAmount = paymentMethod === "free"
          ? 0
          : paymentMethod === "stripe"
            ? basePaymentAmount * 1.03
            : basePaymentAmount;

        console.log(`AdminInquire ${source} - Plan ID:`, planId, 'Purchasable Addon IDs:', purchasableAddonIds);

        this.setState(
          {
            modalVisible: false,
            modalContent: null,
          },
          () => {
            this.setState({
              modalVisible: true,
              modalContent: {
                ...row,
                purchasableAddonIds,
                planAmount,
                paymentAmount,
              },
            });
          }
        );
      };

      // Handler to open the modal
      public handleOpen = () => {
        this.setState({ isEditOpen: true });
      };

      // Handler to close the modal
      public handleClose = () => {
        this.setState({
          isEditOpen: false,
          selectedRow: {},
          selectedPlanAddon: "",
          addonSelect: [],
          membershipIds: [],
          editPaymentOptions: 'check',
          isCustomPriceEnabled: false,
          customPlanPrice: 0,
          customPlanPriceInput: "",
          customAddonPrices: {},
          customAddonInputs: {},
          planStandardPrice: 0,
        });
      };

      public async checkRequestStatus(item: any) {
        const res = await this.checkPendingCheck(item?.id)
        console.log("res========= checkPendingCheck>", res)
        if (res) {
          alert("Customer has a pending check request, Please approve that to edit the subscription.")
        } else {
          this.editButtonClick(item)
        }
      }
      public editButtonClick(item: any) {
        const Ids: any = item?.memberPayHistory?.plan?.id > 1 ? item?.memberPayHistory?.plan?.id : 1
        const initialPlanMatch: any = this.state.planOptions?.find((p: any) => Number(p.value) === Number(Ids));
        const initialPlanPrice: number = initialPlanMatch ? Number(initialPlanMatch.price) : 0;
        this.setState({ selectedRow: item, selectedPlanAddon: Ids,  customPlanPrice: item?.memberPayHistory?.price,isCustomPriceEnabled: item?.is_custom_price,
           customPlanPriceInput: (item?.memberPayHistory?.price !== undefined && item?.memberPayHistory?.price !== null && item?.is_custom_price)
            ? `$${Number(item?.memberPayHistory?.price).toFixed(2)}`
            : "",
           planStandardPrice: initialPlanPrice,
           editPaymentOptions: item?.subscription_type }, () => {
          this.setState({ addonOptions: this.selectOptionAddon(), addonSelect: [] })
          this.addonsIdHandler(item?.memberPayHistory?.subscription_id,  this.state.addonSelect)
        })

      }
      public cancelSubscription(item: any) {
        this.setState({ selectedRow: item }, () => {
          this.setState({ cancelSubscription: true })
        })
      }

public async addonsIdHandler(id: any, selectedAddonIds: any[]) {

        // console.log("Running on edit")
        this.setState({ loader: true })
        const res: any = await this.buildGet(this, `payment/getOneAddonHistory/${id}`)()
        console.log("addonsIdHandler edit data::::", res)
if (res?.status && Array.isArray(res.data)) {
  // Get current plan's compatible addon IDs
  const currentPlanAddons = this.state.addonOptions.map((addon: any) => addon.value);
  
  const customAddonPrices: Record<number, number> = {};
  const customAddonInputs: Record<number, string> = {};

  res.data.forEach((item: any) => {
    if (item?.addon?.id && item?.price !== undefined) {
      const id = item.addon.id;
      // Only set prices for addons compatible with current plan
      if (currentPlanAddons.includes(id)) {
        const price = Number(item.price);
        customAddonPrices[id] = price;
        customAddonInputs[id] = `$${price.toFixed(2)}`;
      }
    }
  });
  if (this.state.isCustomPriceEnabled) {
    this.setState({ customAddonPrices, customAddonInputs });
  }
}
        if (res?.status) {
          const data: any = []
          if (res?.data.length > 0) {
            this.setState({ membershipIds: res?.data })
            res?.data.map((item: any) => {
              data.push(item.addon.id)
            })

console.log("addonsIdHandler functio>", data, selectedAddonIds)
            
            // Get current plan's compatible addon IDs
            const currentPlanAddons = this.state.addonOptions.map((addon: any) => addon.value);
            
            // Filter: Only keep addons that are compatible with current plan
            const compatibleAddons = data.filter((addonId: any) => 
              currentPlanAddons.includes(addonId)
            );
            
            console.log("Current plan compatible addons:", currentPlanAddons);
            console.log("Filtered compatible addons:", compatibleAddons);
            
            const updatedStarterAddon = this.state.addonOptions.filter((addon: any) => !compatibleAddons.includes(addon.value));

            console.log(updatedStarterAddon);
            if (this.state.addonOptions.length > 0) {
              // Filter customAddonPrices to only keep compatible addons
              const filteredCustomAddonPrices: Record<string | number, number> = {};
              const filteredCustomAddonInputs: Record<string | number, string> = {};
              
              compatibleAddons.forEach((addonId: any) => {
                if (this.state.customAddonPrices?.[addonId] !== undefined) {
                  filteredCustomAddonPrices[addonId] = this.state.customAddonPrices[addonId];
                }
                if (this.state.customAddonInputs?.[addonId] !== undefined) {
                  filteredCustomAddonInputs[addonId] = this.state.customAddonInputs[addonId];
                }
              });
              
              this.setState({ 
                addonSelect: compatibleAddons,
                customAddonPrices: filteredCustomAddonPrices,
                customAddonInputs: filteredCustomAddonInputs
              })
              this.handleOpen()
            } else {
              this.handleOpen()
            }

          } else {

            this.handleOpen()
          }
          // this.handleOpen()
        }
        this.setState({ loader: false })
      }

      public async addonsIdHandlerOptions(id: any) {
        //  console.log("Running on non edit")
        this.setState({ loader: true })
        const res: any = await this.buildGet(this, `payment/getOneAddonHistory/${id}`)()
// if (res?.status && Array.isArray(res.data)) {
//   const customAddonPrices: Record<number, number> = {};

//   res.data.forEach((item: any) => {
//     if (item?.addon?.id && item?.price !== undefined) {
//       customAddonPrices[item.addon.id] = item?.addon?.price;
//     }
//   });

//   this.setState({ customAddonPrices });
// }
        if (res?.status) {
          const data: any = []
          if (res?.data.length > 0) {
            this.setState({ membershipIds: res?.data })
            res?.data.map((item: any) => {
              data.push(item.addon.id)
            })

console.log("addonsIdHandlerOptions functio>", data)
            
            // Get current plan's compatible addon IDs
            const currentPlanAddons = this.state.addonOptions.map((addon: any) => addon.value);
            
            // Filter: Only keep addons that are compatible with current plan
            const compatibleAddons = data.filter((addonId: any) => 
              currentPlanAddons.includes(addonId)
            );
            
            console.log("Current plan compatible addons:", currentPlanAddons);
            console.log("Filtered compatible addons:", compatibleAddons);
            
            const updatedStarterAddon = this.state.addonOptions.filter((addon: any) => !compatibleAddons.includes(addon.value));

            console.log(updatedStarterAddon);
            if (this.state.addonOptions.length > 0) {
              // Filter customAddonPrices to only keep compatible addons
              const filteredCustomAddonPrices: Record<string | number, number> = {};
              const filteredCustomAddonInputs: Record<string | number, string> = {};
              
              compatibleAddons.forEach((addonId: any) => {
                if (this.state.customAddonPrices?.[addonId] !== undefined) {
                  filteredCustomAddonPrices[addonId] = this.state.customAddonPrices[addonId];
                }
                if (this.state.customAddonInputs?.[addonId] !== undefined) {
                  filteredCustomAddonInputs[addonId] = this.state.customAddonInputs[addonId];
                }
              });
              
              // Only set compatible addons, not all loaded addons
              this.setState({ 
                addonSelect: compatibleAddons,
                customAddonPrices: filteredCustomAddonPrices,
                customAddonInputs: filteredCustomAddonInputs
              })
              // this.handleOpen()
            } else {
              // this.handleOpen()
            }

          } else {

            // this.handleOpen()
          }
          // this.handleOpen()
        }
        this.setState({ loader: false })
      }
      public renderPlanEditDropdown() {
        // Show any plan whose label contains 'free' or 'elite' (case-insensitive)
        return (
          <FormControl variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">Plan Type</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={this.state.selectedPlanAddon}
              onChange={this.planEditChange}
              label="Plan Type"
            >
              {this.state.planOptions?.filter((plan: any) => {
                const label = String(plan.label).toLowerCase();
                return label.includes("free") || label.includes("elite");
              }).map((plan: any) => (
                <MenuItem key={plan.value} value={plan.value}>
                  <ListItemText primary={plan.label} secondary={`$${plan.price}/yr`} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )
      }
      public handleAddonChange = (
  event: React.ChangeEvent<{ value: unknown }>
) => {
  const selectedIds = event.target.value as number[];

  this.setState((prevState: ITemplatesPageState) => {
    const prevMap = new Map<number, string>(
      prevState.selectedAddonPrices.map(a => [a.addonId, a.price])
    );

    const updatedAddonPrices = selectedIds.map(id => ({
      addonId: id,
      price: prevMap.get(id) ?? "" 
    }));

    return {
      addonSelect: selectedIds,
      selectedAddonPrices: updatedAddonPrices
    };
  });
};


      public selectOptionAddon() {
        switch (this.state.selectedPlanAddon) {
          case 2:
            return starterAddon
          case 3:
            return proAddon
          case 4:
            return premierAddon
            case 5:
              return eliteAddon
          default:
            return []
        }
      }

      public manageAddonSelectUnselect() {
        const data = this.state.membershipIds?.map((item: any) => item?.addon?.id) || []
        const newData = this.state.addonSelect || []

        const NewAddon = newData?.filter((item: any) => !data.includes(item)) || [];
        const RemoveAddon = data?.filter((value: any) => !newData.includes(value)) || [];
        const AddonExist = newData?.filter((item: any) => data.includes(item)) || [];
        console.log(NewAddon, RemoveAddon, AddonExist);


        return { add: NewAddon, remove: [...RemoveAddon] }
      }
      public submitUpgradePlanAddon() {
        console.log("this.state.customAddonPrice, this.state.customPlanPrice, this.state.customAddonPrices",
          this.state.customAddonPrice, this.state.customPlanPrice, this.state.customAddonPrices)
        // Always validate plan & addon inputs safely
const { isCustomPriceEnabled, customPlanPriceInput } = this.state;

// Always ensure plan is selected
if (!this.state.selectedPlanAddon) {
  alert("Please select a plan before submitting.");
  return;
}

// Validate plan price input (mandatory only if custom pricing is ON)
const planPriceProvided =
  String(customPlanPriceInput || "").trim() !== "" &&
  customPlanPriceInput !== ".";

if (isCustomPriceEnabled && !planPriceProvided) {
  alert("Please enter custom plan price.");
  return;
}
const selectedAddonIds: Array<string | number> = this.state.addonSelect || [];
console.log("this.state.selectedAddonPrices", this.state.selectedAddonPrices);
const missingAddonPrice =
  isCustomPriceEnabled &&
  this.state.selectedAddonPrices.some(
    (a: any) => a.price === "" || a.price === "."
  );

if (missingAddonPrice) {
  alert("Please enter custom price for all selected addons.");
  return;
}

//  Extra validation: If custom price ON and total (plan + addons) is 0,
//    then user must select payment type "free"
if (isCustomPriceEnabled) {
  const planPrice = Number(this.state.customPlanPrice || 0);

  const addonTotal: number = (selectedAddonIds || []).reduce<number>((sum, id: string | number) => {
    const key = String(id);
    const price = this.state.customAddonPrices?.[key];
    const numeric = price !== undefined && price !== null ? Number(price) : 0;
    return sum + (isNaN(numeric) ? 0 : numeric);
  }, 0);

  const grandTotal = planPrice + addonTotal;
  console.log("grandTotal", grandTotal, this.state.editPaymentOptions);

  if (grandTotal === 0 && this.state.editPaymentOptions !== "free") {
    alert("Total custom price of plan is $0.00. Please select subscription type 'Free'.");
    return;
  }
}

        if (this.state.selectedPlanAddon > 0 || (this.manageAddonSelectUnselect().add?.length > 0 || this.manageAddonSelectUnselect().remove?.length > 0)) {
          if (this.state.selectedPlanAddon === 1) {
            alert("Select Valid Plan or Addon for update subscription")
          } else {
            this.setState({ loader: true })
            // console.log("this.state.selectedPlanAddon === this.state.selectedRow?.memberPayHistory?.plan?.id", this.state.selectedPlanAddon === this.state.selectedRow?.memberPayHistory?.plan?.id, this.state.selectedPlanAddon, this.state.selectedRow?.memberPayHistory?.plan?.id)
            if (this.state.selectedPlanAddon === this.state.selectedRow?.memberPayHistory?.plan?.id) {
              Promise.all([this.addonUpgradeSubscription()])
                .then(([data1]) => {
                  // Both API responses are available here
                  console.log('Data from API 1:', data1);
                  if (!data1.status) {
                    this.setState({ loader: false })
                    alert(data1?.message)
                  } else {
                    this.handleClose()
                    this.getChequeDataHandler()
                  }
                })
                .catch(error => {
                  // Handle any errors from either API
                  console.error('Error fetching data:', error);
                  this.setState({ loader: false })
                  alert("Please try again!")

                });
            } else {
              if (this.manageAddonSelectUnselect().add?.length > 0 || this.manageAddonSelectUnselect().remove?.length > 0) {
                Promise.all([this.planUpgradeSubscription(), this.addonUpgradeSubscription()])
                  .then(([data1, data2]) => {
                    // Both API responses are available here
                    console.log('Data from API 1:', data1);
                    console.log('Data from API 2:', data2);
                    if (!data1.status) {
                      this.setState({ loader: false })
                      alert(data1?.message)
                    } else if (!data2?.status) {
                      this.setState({ loader: false })
                      alert(data2?.message)
                    } else {
                      this.handleClose()
                      this.getChequeDataHandler()
                    }
                  })
                  .catch(error => {
                    // Handle any errors from either API
                    console.error('Error fetching data:', error);
                    this.setState({ loader: false })
                    alert("Please try again!")

                  });
              } else {
                Promise.all([this.planUpgradeSubscription()])
                  .then(([data1]) => {
                    // Both API responses are available here
                    console.log('Data from API 1:', data1);
                    if (!data1.status) {
                      this.setState({ loader: false })
                      alert(data1?.message)
                    } else {
                      this.handleClose()
                      this.getChequeDataHandler()
                    }
                  })
                  .catch(error => {
                    // Handle any errors from either API
                    console.error('Error fetching data:', error);
                    this.setState({ loader: false })
                    alert("Please try again!")

                  });
              }

            }
          }

        } else {

          alert("Select Plan or Addon for update subscription")

        }

      }

      public async planUpgradeSubscription() {
        try {
          const userRes: any = await this.buildGet(this, "user")();
          //  const addedAddonIds = this.manageAddonSelectUnselect().add || []
const formattedAddonPrices = (this.state.addonSelect || []).map((addonId: any) => {
  const matched = this.state.addonOptions.find(
    (opt: any) => Number(opt.value) === Number(addonId)
  );

  return {
    id: Number(addonId),
    price: Number(matched?.price || 0),
  };
});
console.log("this.state.addonSelect", this.state.addonSelect);
console.log("this.state.addonOptions", this.state.addonOptions);
console.log("formattedAddonPrices2 (all addonOptions with id + price):", formattedAddonPrices);

          const payload: any = {
            membership_id: this.state.selectedRow?.id,
            type: "plan",
            plan_id: this.state.selectedPlanAddon,
            addon_id: formattedAddonPrices,
            subscription_type: this.state.editPaymentOptions,
            price: this.state.planStandardPrice,
            updateby: userRes?.id,
            is_custom_price: this.state.isCustomPriceEnabled,
          };
          console.log("plan upgrade payload", payload)

          const res: any = await this.buildPut(
            this,
            `/payment/updateMembership`
          )(payload);
          return res

        } catch (error) {
          return { isError: true, message: error }
        }
      }

      public async addonUpgradeSubscription() {
        const removeIDs: any = [];

this.state.membershipIds.forEach((item: any) => {
  if (!this.state.addonSelect.includes(item.addon.id)) {
    removeIDs.push(item.id);
  }
});


        // Build custom addon prices map only for newly added addons with a positive price
        const addedAddonIds = this.manageAddonSelectUnselect().add || []
        const customAddonPrices: any = {}
        addedAddonIds.forEach((addonId: any) => {
          const price = this.state.customAddonPrices?.[addonId]
          if (price && Number(price) > 0) {
            customAddonPrices[addonId] = Number(price)
          }
        })
        // addon Format
//  [{
//             id: values
//             price: 100
//            }]
const res: any = await this.buildGet<IUser>(this, "user")();
let payload: any = {};

  //  Condition: check if custom price is enabled
  if (this.state.isCustomPriceEnabled) {
    // When custom price is ON → send id + price object
    const addedAddonIds = this.state.addonSelect || []; 

const formattedAddonPrices = addedAddonIds.map((addonId: any) => {
  const price = this.state.customAddonPrices?.[addonId];

  return {
    id: Number(addonId),
    price: price ? Number(price) : 0,
  };
});
console.log("formattedAddonPrices with custom prices", formattedAddonPrices, this.state.customAddonPrices);
    payload = {
      membership_id: this.state.selectedRow?.id,
      type: "addon",
      plan_id: this.state.selectedPlanAddon,
      addon_id: formattedAddonPrices,  // array of objects: [{id: number, price: number}]
      remove_addon_id: removeIDs,
      subscription_type: this.state.editPaymentOptions,
      price: this.state.customPlanPrice,
      updateby: res?.id,
      is_custom_price: this.state.isCustomPriceEnabled,
    };
  } else {
   // When custom price is OFF → old logic
//       const formattedAddonPrices = addedAddonIds.map((addonId: any) => {
//   const matchedAddon = this.state.addonOptions?.find(
//     (opt: any) => Number(opt.value) === Number(addonId)
//   );

//   const price = matchedAddon?.price;

//   return {
//     id: Number(addonId),
//     price: price ? Number(price) : 0, // default 0 if not found
//   };
// });
const formattedAddonPrices = (this.state.addonSelect || []).map((addonId: any) => {
  const matched = this.state.addonOptions.find(
    (opt: any) => Number(opt.value) === Number(addonId)
  );

  return {
    id: Number(addonId),
    price: Number(matched?.price || 0),
  };
});

console.log("this.state.addonSelect", this.state.addonSelect);
console.log("this.state.addonOptions", this.state.addonOptions);
console.log("formattedAddonPrices1 (all addonOptions with id + price):", formattedAddonPrices);

    payload = {
      membership_id: this.state.selectedRow?.id,
      type: "addon",
      plan_id: this.state.selectedPlanAddon,
      addon_id: formattedAddonPrices, // array of addon ids
      remove_addon_id: removeIDs,
      subscription_type: this.state.editPaymentOptions,
      updateby: res?.id,
       is_custom_price: false,
       price: this.state.planStandardPrice,
    };
  }
console.log("final payload", payload, this.state.isCustomPriceEnabled )

        try {
          // const res: any = [];
          const res: any = await this.buildPut(
            this,
            `/payment/updateMembership`
          )(
            payload
          //   {
          //   "membership_id": this.state.selectedRow?.id,
          //   "type": "addon",
          //   "plan_id": this.state.selectedPlanAddon,
          //   // "addon_id": this.manageAddonSelectUnselect().add,
          //   "remove_addon_id": removeIDs,
          //   "subscription_type": this.state.editPaymentOptions,
          //   // send custom addon prices when provided
          //   // "custom_addon_prices": formattedAddonPrices
          //   "addon_id": formattedAddonPrices,
          //               "price": this.state.customPlanPrice
          
          // }
        );
          return res
        } catch (error) {
          return { isError: true, message: error }
        }
      }
public handleCustomPriceToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
   // this.setState({ isCustomPriceEnabled: event.target.checked });
  const checked = event.target.checked;

  this.setState((prev: any) => ({
    isCustomPriceEnabled: checked,

    // ⭐ IMPORTANT: Select ko sirf already-selected addons tak limit karo
    addonSelect: checked ? [...prev.addonSelect] : prev.addonSelect,

    // ⭐ Sirf unhi addons ke price blank karo
    selectedAddonPrices: checked
      ? prev.addonSelect.map((id: number) => ({
          addonId: id,
          price: ""
        }))
      : prev.selectedAddonPrices,

    customAddonInputs: checked ? {} : prev.customAddonInputs,
    customAddonPrices: checked ? {} : prev.customAddonPrices
  }));
}



public multipleAddonSelectReder() {
  const { addonSelect, addonOptions, isCustomPriceEnabled } = this.state;

   if (addonOptions.length === 0) {
          return null
        }
  return (
    <FormControl style={{ minWidth: 200, marginTop: isCustomPriceEnabled ? "20px" : "0px", }}>
      <InputLabel>Select Addons</InputLabel>
      {console.log("addonSelectdropdown", addonSelect)}
      <Select
        multiple={true}
        value={addonSelect}
        onChange={this.handleAddonChange}
         renderValue={(selected: unknown) => {
    const selectedLabels = (selected as string[])
      .map((val) => addonOptions.find((option: any) => option.value === val)?.label)
      .filter((label): label is string => Boolean(label)); // remove❗undefined/empty 
    return selectedLabels.join(', ');
  }}
      >
        {console.log("addonOptions22", addonOptions)}
        {addonOptions.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={addonSelect.indexOf(option.value) > -1} />
            <ListItemText primary={option.label} secondary={`$${option?.price}/yr`}/>
          </MenuItem>
        ))}
      </Select>
        <div className="price-wrapper">
      {/* ✅ Addon Custom Price if checkbox enabled */}
      {isCustomPriceEnabled &&
        addonSelect
          .sort((a: any, b: any) => Number(a) - Number(b))
          .map((addonIdRaw: string | number, index: number) => {
            const addonId = Number(addonIdRaw);
            const addon = addonOptions.find(
              (opt: any) => Number(opt.value) === addonId
            );
            if (!addon) {return null;}

           const numericValue =
              this.state.customAddonPrices?.[addonId] !== undefined
                ? this.state.customAddonPrices[addonId]
                : undefined;
           const inputValue =
              this.state.customAddonInputs?.[addonId] !== undefined
                ? this.state.customAddonInputs[addonId]
                : (numericValue !== undefined && numericValue !== null
                    ? `$${Number(numericValue).toFixed(2)}`
                    : "");

            return (
              <>
              
              <div
                key={`${addonId}-${index}`}
                style={{
                  marginTop: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 10,
                }}
              >
                           <label style={{margin: "0", width: "100%"}} htmlFor={`addon-${addonId}`}>
                  Custom Price for {addon.label} <span className="text-danger">*</span>
                  <input
                    id={`addon-${addonId}`}
                    type="text"
                    value={inputValue}
                    placeholder={`$${Number(addon.price).toFixed(2)} (Click here to edit)`}
                   onChange={(e) => {
                                          // Remove all non-numeric characters except dot
  const raw = e.target.value.replace(/[^0-9.]/g, "");
  this.setState((prev: any) => ({
    customAddonInputs: { ...prev.customAddonInputs, [addonId]: raw },
    customAddonPrices: { ...prev.customAddonPrices, [addonId]: raw ? parseFloat(raw) : 0 },

    //  NEW STATE UPDATE
    selectedAddonPrices: prev.selectedAddonPrices.map((a: any) =>
      a.addonId === addonId ? { ...a, price: raw } : a
    )
  }));
}}
                    onFocus={(e) => {
                      // Select the number part for easy editing
                      const inputEl = e.currentTarget;
                      requestAnimationFrame(() => inputEl.select());
                    }}

                onBlur={() => {
  const raw = this.state.customAddonInputs?.[addonId] || "";

  let finalPrice = "";

  if (raw !== "" && raw !== "." && !isNaN(Number(raw))) {
    finalPrice = Number(parseFloat(raw).toFixed(2)).toString();
  }

  this.setState((prev: any) => ({
    customAddonInputs: {
      ...prev.customAddonInputs,
      [addonId]: finalPrice ? `$${Number(finalPrice).toFixed(2)}` : ""
    },
    customAddonPrices: {
      ...prev.customAddonPrices,
      [addonId]: finalPrice ? Number(finalPrice) : 0
    },

    // keep addon price in sync
    selectedAddonPrices: prev.selectedAddonPrices.map((a: any) =>
      a.addonId === addonId ? { ...a, price: finalPrice } : a
    )
  }));
}}

                style={{ padding: "5px", color: "rgba(0, 0, 0, 0.54)", width: "100%", border: "none", borderBottom: "1px solid rgb(204, 204, 204)" }}
                  />
                </label>


  {/* <TextField
                type="text"
                size="small"
                // label={`Custom Price for ${addon.label}`}
                required={true}
                placeholder={`$${Number(addon.price).toFixed(2)} (Click here to edit)`}
                value={inputValue}
                onChange={(e) => {
                  const next = e.target.value;
                  const sanitized = next.replace(/[^0-9.]/g, "");
                  const parts = sanitized.split(".");
                  const normalized =
                    parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : sanitized;
                  this.setState((prev: any) => ({
                    customAddonInputs: { ...prev.customAddonInputs, [addonId]: normalized },
                  }));
                }}
                onBlur={() => {
                  const raw = this.state.customAddonInputs?.[addonId] || "";
                  if (raw === "" || raw === ".") {
                    this.setState((prev: any) => ({
                      customAddonPrices: { ...prev.customAddonPrices, [addonId]: 0 },
                      customAddonInputs: { ...prev.customAddonInputs, [addonId]: "" },
                    }));
                    return;
                  }
                  const num = Number(parseFloat(raw).toFixed(2));
                  if (!isNaN(num)) {
                    this.setState((prev: any) => ({
                      customAddonPrices: { ...prev.customAddonPrices, [addonId]: num },
                      customAddonInputs: { ...prev.customAddonInputs, [addonId]: `$${num.toFixed(2)}` },
                    }));
                  } else {
                    this.setState((prev: any) => ({
                      customAddonPrices: { ...prev.customAddonPrices, [addonId]: 0 },
                      customAddonInputs: { ...prev.customAddonInputs, [addonId]: "" },
                    }));
                  }
                }}
                onFocus={(e) => {
                  const val = this.state.customAddonInputs?.[addonId] ?? inputValue;
                  const withoutCurrency = String(val).replace(/[^0-9.]/g, "");
                  this.setState((prev: any) => ({
                    customAddonInputs: { ...prev.customAddonInputs, [addonId]: withoutCurrency },
                  }));
                  const inputEl = e.currentTarget as any;
                  requestAnimationFrame(() => {
                    if (inputEl && typeof inputEl.select === "function") {
                      try { inputEl.select(); } catch (_) { /* noop 
                    }
                  });
                }}
                style={{ flex: 1 }}
              /> */}

                 {/* <InfoIcon
    style={{ color: "#1976d2", cursor: "pointer" }}
    titleAccess="Click here to edit price"
  /> */}
              </div>
               </>
            );
          })}
              </div>
    </FormControl>
  )
}
      public handleChangePlanType = (event: any) => {
        this.setState({ editPaymentOptions: event.target.value });
      };
public EditModalRender() {
  const { classes } = this.props;
  const { isCustomPriceEnabled } = this.state;

  return (
    <Modal
      open={this.state.isEditOpen}
      onClose={this.handleClose}
      className={classes.modal}
     closeAfterTransition={true}
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
    >
      <Fade in={this.state.isEditOpen}>
                      <div className="modal-subscription modal-innerdiv">
                <div className="close-btn-modal">
                              <h2>Select Subscription Plan </h2>
            <span style={{cursor:"pointer"}} className="" onClick={this.handleClose}>
              <CloseIcon />
            </span>
          </div>
          <div>
            {Object.keys(this.state.selectedRow).length > 0 && this.renderPlanEditDropdown()}
          </div>
      <div  style={{overflowY: "auto", maxHeight:"368px"}} className="add_scroll" >
          {/* ✅ Custom Price Toggle */}
          <div style={{ marginTop: 5 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isCustomPriceEnabled}
                  onChange={this.handleCustomPriceToggle}
                  color="primary"
                />
              }
              label="Want to add custom price?"
            />
          </div>

          {/* Plan Custom Price Input */}
          {isCustomPriceEnabled && this.state.selectedPlanAddon && (
            <div className="changeLebelColor" style={{ marginTop: "0px" }}>
              
              <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <label htmlFor="customPrice" style={{ marginBottom: "0px",fontWeight: "500" }} >
                  Custom Price for Plan <span className="text-danger">*</span>
                </label>
                <input
                  id="customPrice"
                  type="text"
                  value={this.state.customPlanPriceInput}
                  // onChange={(e) => this.setState({ customPlanPriceInput: e.target.value })}
                    placeholder={
                          (() => {
                            const plan = this.state.planOptions?.find(
                              (p: any) => Number(p.value) === Number(this.state.selectedPlanAddon)
                            );
                            return plan ? `$${Number(plan.price).toFixed(2)} (Click here to edit)` : "(Click here to edit)";
                          })()
                        }
                  style={{
                    padding: "5px",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    color: "rgb(0 0 0 / 54%)"
                    
                  }}
                 
                  onBlur={() => {
                                const raw = this.state.customPlanPriceInput;
                                if (raw === "" || raw === ".") {
                                  this.setState({ customPlanPrice: 0, customPlanPriceInput: "" });
                                  return;
                                }
                                const num = Number(parseFloat(raw).toFixed(2));
                                if (!isNaN(num)) {
                                  this.setState({
                                    customPlanPrice: num,
                                    customPlanPriceInput: `$${num.toFixed(2)}`,
                                  });
                                } else {
                                  this.setState({ customPlanPrice: 0, customPlanPriceInput: "" });
                                }
                              }}

                     onChange={(e) => {
                          const next = e.target.value;
                          // allow only digits and one dot
                          const sanitized = next.replace(/[^0-9.]/g, "");
                          // prevent multiple dots
                          const parts = sanitized.split(".");
                          const normalized =
                            parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : sanitized;
                          this.setState({ customPlanPriceInput: normalized });
                        }}
                       onFocus={(e) => {
                          const val = this.state.customPlanPriceInput;
                          const withoutCurrency = val.replace(/[^0-9.]/g, "");
                          this.setState({ customPlanPriceInput: withoutCurrency });
                          // select all for easy overwrite
                          const inputEl = e.currentTarget as any;
                          requestAnimationFrame(() => {
                            if (inputEl && typeof inputEl.select === "function") {
                              try { inputEl.select(); } catch (_) { /* noop */}
                            }
                          });
                        }}
                               
                 />
              </div>

          {/* <TextField
                        type="text"
                        size="small"
                        label="Custom Price for Plan"
                        required={true}
                        placeholder={
                          (() => {
                            const plan = this.state.planOptions?.find(
                              (p: any) => Number(p.value) === Number(this.state.selectedPlanAddon)
                            );
                            return plan ? `$${Number(plan.price).toFixed(2)} (Click here to edit)` : "(Click here to edit)";
                          })()
                        }
                        value={this.state.customPlanPriceInput}
                        onChange={(e) => {
                          const next = e.target.value;
                          // allow only digits and one dot
                          const sanitized = next.replace(/[^0-9.]/g, "");
                          // prevent multiple dots
                          const parts = sanitized.split(".");
                          const normalized =
                            parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : sanitized;
                          this.setState({ customPlanPriceInput: normalized });
                        }}
                        onBlur={() => {
                          const raw = this.state.customPlanPriceInput;
                          if (raw === "" || raw === ".") {
                            this.setState({ customPlanPrice: 0, customPlanPriceInput: "" });
                            return;
                          }
                          const num = Number(parseFloat(raw).toFixed(2));
                          if (!isNaN(num)) {
                            this.setState({
                              customPlanPrice: num,
                              customPlanPriceInput: `$${num.toFixed(2)}`,
                            });
                          } else {
                            this.setState({ customPlanPrice: 0, customPlanPriceInput: "" });
                          }
                        }}
                        onFocus={(e) => {
                          const val = this.state.customPlanPriceInput;
                          const withoutCurrency = val.replace(/[^0-9.]/g, "");
                          this.setState({ customPlanPriceInput: withoutCurrency });
                          // select all for easy overwrite
                          const inputEl = e.currentTarget as any;
                          requestAnimationFrame(() => {
                            if (inputEl && typeof inputEl.select === "function") {
                              try { inputEl.select(); } catch (_) { /* noop 
                            }
                          });
                        }}
                        style={{ width: "100%" }}
                      /> */}
              

               {/* <InfoIcon
    style={{ color: "#1976d2", cursor: "pointer" }}
    titleAccess="Click here to edit price"
  /> */}
            </div>
          )}

          {/* Addon Multi Select */}
           <style>
            {`
              .changeLebelColor .MuiSelect-select,
              .changeLebelColor .MuiInputBase-input {
                color: rgb(0 0 0 / 54%);
                font-weight:400;
                font-size:14px;
              }
              /* ensure required asterisk shows red */
              .changeLebelColor .MuiFormLabel-asterisk {
                color: #f44336 !important;
              }
                .price-wrapper {
                 grid-template-columns: repeat(2, 1fr);
                 display: grid;
                 gap:10px;
                }
               .modal-subscription.modal-innerdiv {
                max-width:680px;
                width:100%;
               }
                #demo-simple-select-outlined {
                    padding:5px 14px;
                }
            `}
          </style>  
          {/* <div className="changeLebelColor">{this.multipleAddonSelectReder()}</div> */}

          {/* Payment Type */}
          <div style={{ marginTop: 10 }}>
       <FormControl component="fieldset" style={{ display: "flex", alignItems: "center", gap: "20px", flexDirection: "row" }}>
              <FormLabel component="legend" style={{display: "flex", width: "auto", fontSize:"17px", color: "#000",  alignItems: "center", float: "left", fontWeight: "500"}}>Subscription Type</FormLabel>
              <RadioGroup style={{flexDirection: "row"}} value={this.state.editPaymentOptions} onChange={this.handleChangePlanType}>
                <FormControlLabel value="cheque" control={<Radio />} label="Check" />
                <FormControlLabel value="stripe" control={<Radio />} label="Stripe" />
                <FormControlLabel value="free" control={<Radio />} label="Free" />
                   {/* <FormControlLabel value="option3" control={<Radio />} label="Option 3" />  */}
              </RadioGroup>
            </FormControl>



            </div>
          </div>
           {/* <div className="sub-btn-inquire-modal">
                  <button onClick={() => {
                    this.submitUpgradePlanAddon()
                    // if (this.state.editPaymentOptions === "free") {
                    //   alert("Please select payment type")
                    // } else {
                    //   this.submitUpgradePlanAddon()
                    // }

                  }} disabled={this.state.loader ? true : false}>
                    Submit
                  </button>
                </div> */}

        <div className="sub-btn-inquire-modal">
            <button
              onClick={() => {
                      // Check if the selected plan is a downgrade
                const currentPlanId = this.state.selectedRow?.memberPayHistory?.plan?.id;
                const selectedPlanId = this.state.selectedPlanAddon; // Assuming this stores the selected plan's ID

                if (selectedPlanId && selectedPlanId < currentPlanId) {
                           // Block downgrade - show alert and prevent submission
                    window.alert("Plan downgrade is not allowed. Please select a plan that is equal to or higher than your current plan.");
                    return; // Do nothing - prevent downgrade
                }

      // Proceed with submission if no downgrade
                this.submitUpgradePlanAddon();
              }}
                 disabled={this.state.loader ? true : false}
            >
              Submit
            </button>
          </div>
        </div>
      </Fade>
    </Modal>
  )
}

      public async cancelSubHandler(type = "") {
        this.setState({ loader: true });
        try {
          const res: any = await this.buildPut(
            this,
            `payment/membershipCancelled/${this.state.selectedRow.id}`
          )({
            type,
          });

          if (res.status) {
            this.setState({ loader: false, cancelSubscription: false });
            this.getChequeDataHandler()
          } else {
            alert("Failed Cancel Subscription. Please try again.");
            this.setState({ loader: false });
          }
        } catch (error) {
          console.error("Error updating status:", error);
          this.setState({ loader: false });
          alert("An error occurred. Please try again.");
        } finally {
          this.setState({ loader: false });
        }
      }
      public CancelModalRender() {
        const { classes } = this.props;
         return (
          <Modal
            open={this.state.cancelSubscription}
            onClose={() => { this.setState({ cancelSubscription: false }) }}
            className={classes.modal}
            closeAfterTransition={true}
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={this.state.cancelSubscription}>
              <div className="modal-innerdiv">
                <div className="close-btn-modal">
                  <h2>Cancel Subscription?</h2>
                  <span style={{cursor:"pointer"}} className="" onClick={() => { this.setState({ cancelSubscription: false }) }}>
                    <CloseIcon />
                  </span>
                </div>
                <h6>Are you sure you want to cancel this subscription?</h6>
                <div className="sub-btn-inquire-modal">
                  <button onClick={() => {
                    this.cancelSubHandler("")
                  }} style={{ width: 250 }} disabled={this.state.loader ? true : false}>
                    Cancel when subscription renews.
                  </button>
                  <button style={{ marginLeft: 20, width: 300 }} onClick={() => {
                    this.cancelSubHandler("block")
                  }} disabled={this.state.loader ? true : false}>
                    Cancel subscription immediately and block.
                  </button>
                </div>

              </div>
            </Fade>
          </Modal>
        )
      }
      public render() {

        return (
          <>
            {this.state.loader && <div className="loader-bg-color">
              <LoadingSpinner /></div>}
            <Page className="admin-inquire" header="Membership">
              <SimpleTabs
                value={this.state.selectedTab}
                data={["Check Request", "Membership History"]}
                onChange={(value: number) => {
                  this.setState({
                    statusFilter: "",
                    paymentby: "",
                    planFilter: "",
                    search: "",
                    getChequeData: [],
                    currentPage: 1,
                    totalPage: 1,
                    idRange: 1,
                    selectedTab: value
                  }, () => {
                    this.getChequeDataHandler()
                  })

                }} />
              <TabPanel value={this.state.selectedTab} index={0}>
                <div className="filter-inner">
                  <div className="status-payment">
                    <div className="status-inner">
                      {this.renderCheckStatusFilterDropdown()}
                    </div>
                    <div className="payment-inner">
                      {this.renderPaymentFilterDropdown()}
                    </div>
                  </div>
                  <div className="plan-search">
                    <div className="plan-inner">
                      {this.renderPlanFilterDropdown()}
                    </div>
                    <div className="search-inner">
                      {this.renderSearchFilter()}</div>
                  </div>
                  <div className="search-clear-btn">
                    <Button className="serch-bttn" variant="contained" color="primary" onClick={this.handleSubmit}>
                      Search
                    </Button>
                    <Button variant="contained" color="primary" onClick={() => {
                      this.setState({
                        statusFilter: "",
                        paymentby: "",
                        planFilter: "",
                        search: ""
                      }, () => {
                        this.handleSubmit()
                      })
                    }}>
                      Clear Filter
                    </Button>
                  </div>
                </div>
                <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow className='subscription-row'>
                        <TableCell>#</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>School</TableCell>
                        <TableCell>E-mail</TableCell>
                        {/* <TableCell>Type</TableCell> */}
                        <TableCell>Plan</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.getChequeData?.map((row: any, index: number) => {
                        const count = this.getPageItems()
                        return (
                          <TableRow key={row.id} className='subscription-even'>
                            <TableCell>{count + index}</TableCell>
                            <TableCell>
                              {this.CFS(row?.user?.firstName)} {this.CFS(row?.user?.lastName)}
                            </TableCell>
                            <TableCell style={{width:"250px",wordBreak:"break-word"}}  >{this.CFS(row?.school?.name)}</TableCell>
                            <TableCell>{row?.user?.email}</TableCell>
                            {/* <TableCell>{this.CFS(row?.type)}</TableCell> */}
                            <TableCell>
                              {this.CFS(row?.plan?.title)}
                            </TableCell>
                            <TableCell>
                              {/* {moment(row?.memberPayHistory?.subscriptionDate).format('MM/DD/YYYY')} */}
                              {moment((row?.created_at?.split("T")[0]),"YYYY-MM-DD").format('MM/DD/YYYY')} 
                            </TableCell>
                            <TableCell>{this.CFS(row.status)}</TableCell>
                            <TableCell>
                              <div className="active-btn">
                                <button
                                  className="view-btn"
                                  onClick={() => this.handleViewClick(row, "(Tab 0)")}
                                >
                                  View
                                </button>
                                {/* </div>
                              <div className="active-btn"> */}
                                {row.status === "accepted" ? (
                                  ""
                                ) : row.status === "pending" ? (
                                  <>
                                    <button
                                      className="accept-btn"
                                      onClick={() =>
                                        this.updateStatusHandler(
                                          row.id,
                                          "accepted"
                                        )
                                      }
                                    >
                                      Paid
                                    </button>
                                    <button
                                      className="reject-btn"
                                      onClick={() => {
                                        const planId = row?.plan?.id || row?.memberPayHistory?.plan?.id;
                                        const purchasableAddonIds = this.getPurchasableAddonsByPlanId(planId);
                                        this.setState({
                                          rejectModalVisible: true,
                                          modalContent: { ...row, purchasableAddonIds },
                                        });
                                      }}
                                    >
                                      Block
                                    </button>
                                  </>

                                ) : row.status === "declined" ? (
                                  <button
                                    className="accept-btn"
                                    onClick={() =>
                                      this.updateStatusHandler(row.id, "accepted")
                                    }
                                  >
                                    Accept
                                  </button>
                                ) : null}
                              </div>
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>

                </TableContainer>
                <div style={{ marginTop: 30 }}>
                  <Pagination
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    count={this.state.totalPage}
                    page={this.state.currentPage}
                    onChange={this.handlePageChange}
                    variant="outlined"
                    color="primary"
                  />
                </div>

              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={1}>

                <div className="filter-inner">
                  <div className="status-payment">
                    <div className="status-inner">
                      {this.renderStatusFilterDropdown()}
                    </div>
                    <div className="payment-inner">
                      {this.renderPaymentFilterDropdown()}
                    </div>
                  </div>
                  <div className="plan-search">
                    <div className="plan-inner">
                      {this.renderPlanFilterDropdown()}
                    </div>
                    <div className="search-inner">
                      {this.renderSearchFilter()}
                    </div>
                  </div>
                  <div className="search-clear-btn">
                    <Button className="serch-bttn" variant="contained" color="primary" onClick={this.handleSubmit}>
                      Search
                    </Button>
                    <Button variant="contained" color="primary" onClick={() => {
                      this.setState({
                        statusFilter: "",
                        paymentby: "",
                        planFilter: "",
                        search: ""
                      }, () => {
                        this.handleSubmit()
                      })
                    }}>
                      Clear Filter
                    </Button>
                  </div>
                </div>
                <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow className='subscription-row'>
                        <TableCell>#</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>School</TableCell>
                        <TableCell>E-mail</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>Renewal Date</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Add Note</TableCell>
                        <TableCell>Action</TableCell>
                        
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.getChequeData?.map((row: any, index: number) => {
                        const count = this.getPageItems()
                        return (
                          <TableRow key={row.id} className='subscription-even'>
                            <TableCell>{count + index}</TableCell>
                            <TableCell>
                              {this.CFS(row?.user?.firstName)} {this.CFS(row?.user?.lastName)}
                            </TableCell>
                            <TableCell style={{width:"250px",wordBreak:"break-all"}}>{this.CFS(row?.school?.name)}</TableCell>
                            <TableCell>{row?.user?.email}</TableCell>
                            <TableCell>{this.changeChequeName(this.CFS(row?.subscription_type))}/{this.CFS(row?.memberPayHistory?.plan?.title)}</TableCell>
                            {/* <TableCell>
                              {this.CFS(row?.plan?.title)}
                            </TableCell> */}

                            <TableCell>
                              {/* {moment(row?.memberPayHistory?.subscriptionDate).format('MM/DD/YYYY')} */}
 
                              {moment((row?.memberPayHistory?.subscriptionDate?.split("T")[0]),"YYYY-MM-DD").format('MM/DD/YYYY')} 
                            </TableCell>
                            <TableCell>
                              {/* {moment(row?.memberPayHistory?.validUpto).format('MM/DD/YYYY')} */}

                             <span onClick={(e) => this.handleClickDate( row.id, row?.memberPayHistory?.validUpto?.split("T")[0], row?.memberPayHistory?.subscriptionDate?.split("T")[0])} style={{cursor: "pointer"}}>
                               {moment((row?.memberPayHistory?.validUpto?.split("T")[0]),"YYYY-MM-DD").format('MM/DD/YYYY')} 
                               </span>
                              {/* <input
          type="date"
          // value={row?.memberPayHistory?.validUpto?.split("T")[0]}
           value={row?.memberPayHistory?.validUpto?.split("T")[0] || ""}
           onClick={(e) => this.handleClickDate( row.id)}
          // onChange={(e) => this.handleDateChange(e, row.id)}
          style={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "5px",
            width: "100%",
          }}
        /> */}
                            </TableCell>
                            <TableCell>{this.CFS(row.status)}</TableCell>
                            <TableCell>
                            <div className="active-btn">
                            {row?.status === 'active' &&
                            <button
                        onClick={() => this.handleAddNote(row?.id, row?.note, row?.date_note, row?.note )}
                        className="view-btn"
                      >
                        Note
                      </button>
                      }
                      </div>
                            </TableCell>
                            <TableCell>
                              <div className="active-btn">
                                <button
                                  className="view-btn"
                                  onClick={() => this.handleViewClick(row, "(Tab 1)")}
                                >
                                  View
                                </button>
                                {row?.status === 'active' && <button
                                  className="view-btn"
                                  onClick={() =>
                                    this.checkRequestStatus(row)
                                  }
                                >
                                  Edit
                                </button>}
                                {row?.status === 'active' && <button
                                  className="view-btn"
                                  onClick={() =>
                                    this.cancelSubscription(row)
                                  }
                                >
                                  Cancel
                                </button>}

                              </div>
                            </TableCell>
                            
                          </TableRow>
                        )                      
                      })}
                    </TableBody>
                  </Table>

                </TableContainer>
                <div style={{ marginTop: 30 }}>
                  <Pagination
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    count={this.state.totalPage}
                    page={this.state.currentPage}
                    onChange={this.handlePageChange}
                    variant="outlined"
                    color="primary"
                  />
                </div>

              </TabPanel>
              {this.state.modalVisible && <ViewModal
                open={this.state.modalVisible}
                handleClose={() => this.setState({ modalVisible: false })}
                modalContent={this.state.modalContent}
                selectedTab={this.state.selectedTab}
                isDirector={false}
              />}
              <div>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  // className={classes.modal}
                  open={this.state.rejectModalVisible}
                  onClose={() => {
                    this.setState({ rejectModalVisible: false })
                  }}
                  closeAfterTransition={true}
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  <Fade in={this.state.rejectModalVisible}>
                    <div className="modal-inquiry-pages">
                      <h2 id="transition-modal-title">Are you sure you want to block this user?</h2>
                      <div className="transit-inqure">

                        <button onClick={() => {
                          this.setState({ rejectModalVisible: false })
                        }} className="btn-inquiry-no">No</button>
                        <button onClick={() => {
                          this.setState({ rejectModalVisible: false }, () => {
                            this.updateStatusHandler(
                              this.state.modalContent?.id,
                              "declined"
                            )
                          })
                        }} className="btn-inquiry-yes">Yes</button>
                      </div>
                    </div>
                  </Fade>
                </Modal>
              </div>             
              <Modal open={this.state.noteModalVisible} onClose={this.handleCancelNote}>
  <Fade in={this.state.noteModalVisible}>
  <div className="modal-inquiry-pages modal-inquiry-pagess">
  <div className="modal-inner-page">
      <h2>Added Note </h2> 
      <span style={{cursor:"pointer"}} className="" onClick={()=>{this.handleCancelNote()}}><CloseIcon/></span>
      </div>
      <div className="width-scrollbar-admin">
        {console.log("Notelist", this.state.NoteList)}
      {this.state.NoteList?.map((row: any, index: number) => {
                        // const count = this.getPageItems()
                        return ( 
<>


<table style={{ width: "100%", borderCollapse: "collapse" }}>
  <tbody>
<tr >
  <td style={{ border: "1px solid #ddd", padding: "8px",width:"20%"}}>{row?.date_note !== null && row?.date_note}</td>
<td style={{ border: "1px solid #ddd", padding: "8px" }}><p className="note-writee">{row?.note}</p></td> 
<td style={{ border: "1px solid #ddd", padding: "8px",width:"10%"}}>
<span style={{cursor:"pointer"}} onClick={() => this.handleEdit(true, index, row?.note)}><Edit/></span></td>
<td style={{ border: "1px solid #ddd", padding: "8px",width:"10%"}}>
  <span style={{cursor:"pointer"}} onClick={() => this.handleDeleteNote(index, "remove")}><Delete/></span> 
</td>
</tr>  
</tbody>
</table>
</>
                         )
                        
                      })}
</div>

                      <h3 className="added-new-note-inner">Add New Note <span style={{color:"red"}}>*</span></h3>
       <textarea
        value={this.state.noteInput}
        onChange={(e) => this.setState({ noteInput: e.target.value })}
        placeholder="Enter your note"
        style={{
          width: '100%'
          
        }}
        className="textfield-search"
        
      /> 
      {/* <TextField
              className="textfield-search"
              label="Enter your note"
              variant="outlined"
              value={this.state.noteInput}
              onChange={(e) => this.setState({ noteInput: e.target.value })}
            /> */}
      <div className="modal-actions modal-inner">
        <button className="btn-inquiry-yes" onClick={()=>{this.updateNote("", "newNote")}}>Save</button>

      </div>
    </div>
  </Fade>
</Modal>
<Modal open={this.state.editableDate} onClose={()=>{this.setState({editableDate: false})}}>
  <Fade in={this.state.editableDate}>
  <div className="modal-inquiry-pages date-annual-inner">
    
  <div className="modal-inner-page">
      <h2>Change Date </h2> 
      <span style={{cursor:"pointer"}} className="" onClick={()=>{this.setState({editableDate: false})}}><CloseIcon/></span>
      </div>
      <div className="input-date-file ">
      
       <input
       type="date"
        value={this.state.dateChange}
        min={new Date().toISOString().split("T")[0]} 
        onChange={(e) => this.setState({ dateChange: e.target.value })}
      /> 
  
      <div className="modal-actions modal-inner">
        <button className="btn-inquiry-yes" style={{height: "32px"}} onClick={()=>{this.handleDateRenew()}}>confirm</button>

      </div>
      </div>
    </div>
  </Fade>
</Modal>
<Modal open={this.state.openEditNote} onClose={()=>{ this.setState({
          openEditNote: false,
        });}}>
<Fade in={this.state.openEditNote}>
<div className="modal-inquiry-pages modal-inquiry-pagess">
<div className="modal-inner-page">
<h2>Added Note </h2> 
<span style={{cursor:"pointer"}} className="" onClick={()=>{this.setState({
          openEditNote: false,
        })}}><CloseIcon/></span>
</div>
<div className="input-added-page">
    <input
      type="text"
      value={this.state.editText}
     onChange={(e) => this.setState({ editText: e.target.value })}
    />
    </div>
    <div className="update-btn-inner-sec">
    <button 
    onClick={this.handleNoteEdit}
    >Update</button>
    </div>
    {/* <button
    //  onClick={() => this.setState({ editIndex: -1, editText: "" })}
     >Cancel</button> */}
    
     </div>
     </Fade>
  </Modal>

              <div>
                {this.EditModalRender()}
              </div>
              <div>
                {this.CancelModalRender()}
              </div>
            </Page>

          </>
        )
      }
    }
  )
);


// WEBPACK FOOTER //
// ./src/pages/admin/adminInquire/admininquire.tsx